import { InputMask } from '@react-input/mask';
import { useContext, useEffect, useState } from 'react';
import { FaPhoneAlt, FaRegAddressCard, FaRegUser } from 'react-icons/fa';
import { LiaBirthdayCakeSolid } from "react-icons/lia";
import ReactLoading from 'react-loading';
import BoxAlert from '../../components/boxAlert';
import ReturnButton from '../../components/returnButton';
import CompanyContext from '../../contexts/companyContext';
import '../../css/scrollbar.css';
import { useAppRouter } from '../../hooks/useAppRouter';
import useStorage from '../../hooks/useStorage';
import { analyzeDateBirth } from '../../scripts/analyzeDateBirth';
import NiValidator from '../../scripts/documentValidator';
import axios from '../../services/axios';
import styles from './css/register.module.css';


const stripHtmlTags = (value) => (typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value);

function Register() {
    const storage = useStorage();
    const navigate = useAppRouter();

    const { companyData } = useContext(CompanyContext);
    const [NI, setNi] = useState(null);
    const [name, setName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [birth, setBirth] = useState(null);
    const [warnAlert, setWarnAlert] = useState({ show: false, title: null, text: null });
    const [sucessAlert, setSucessAlert] = useState({ show: false, data: null});
    const [loading, setLoading] = useState(false);


    // WHEN SCREEN IS LOAD
    useEffect(() => {
        document.title = `${companyData?.name}`;

        const data = sessionStorage.getItem('CLIENT_DOCUMENT');

        if(data){
            setNi(JSON.parse(data));
            sessionStorage.removeItem('CLIENT_DOCUMENT');
        }
    }, []);



    const handleValidateRegisterData = async () => {

        try{
            setLoading(true);

            // COUNT NAME LENGTH
            let formatName;
    
            if (name) {
                formatName = name.split(' ');
            }
    
            const validateName = formatName && formatName.length > 1 && formatName[0].length > 1 && formatName[formatName.length - 1].length > 1 ? true : false;
    
            if (!validateName){
                setWarnAlert({show: true, title: 'Alerta', text: 'Insira um nome válido para continuar (nome e sobrenome, sem abreviaturas).'});
                return;
            }
    
            // PHONE BUT ONLY NUMBERS
            let formatPhone;
    
            if (phone) {
                formatPhone = phone.replace(/\(/g, '').replace(/\)/g, '').replace(' ', '').replace(/\-/g, '');
            }
    
            console.warn('BIRTH VALUE BEFORE SCREEN 2:', birth);
    
            const validatePhone = formatPhone && formatPhone.length === 11 ? true : false;
    
            if (!validatePhone) {
                setWarnAlert({show: true, title: 'Alerta', text: 'Insira um telefone válido para continuar com o registro.'});
                return;
            }
            
    
    
            // NI BUT ONLY NUMBERS
            const validateNI = NiValidator(NI);
                
            if (!validateNI) {
                setWarnAlert({show: true, title: 'Alerta', text: 'Insira um CPF válido antes de continuar com o registro.'});
                return;
                
            }
    
            // BIRTH FORMAT
            let formatBirth;
    
            if (!birth) {
                formatBirth = null;
            } else {
                let day = parseInt(birth.slice(0, 2));
                let month = parseInt(birth.slice(3, 5));
                let year = parseInt(birth.slice(6, 10));
                formatBirth = `${year}-${month}-${day}`;
    
                // ANALIZANDO O VALOR DE DATA DE NASCIMENTO PARA CONTROLE DE INSERÇÕES FALSAS
                const analize = await analyzeDateBirth(formatBirth);
                console.warn(formatBirth, analize.value);
    
                const cYear = new Date().getFullYear();
    
                if (!formatBirth || analize.value > 100 || analize.value <= 3 || day < 1 || day > 31 || month < 1 || month > 12 || year > cYear || year <= cYear - 100) {
                    setWarnAlert({show: true, title: 'Erro', text: 'Analize o valor inserido no campo "data de nascimento" e tente novamente!'});
                    return;
                }
            }
    
            await saveClientData();

        } finally {
            setLoading(false);
        }
    };




    const saveClientData = async () => {
        try {
            setLoading(true);


            const res = await axios.post(`/smartmenu/client/register`, {
                companyId: companyData.id,
                name: name,
                document: NI,
                phone: phone,
                birthDate: birth,
                platform: navigator.platform,
            });

            if (res.status === 201) {

                const {clientId, uuid} = res.data;

                // ARMAZENA OS DADOS DE VALIDAÇÃO NO CACHE <=======================\\
                
                    let clientValidation = storage.get('CLIENT_VALIDATION');

                    if(clientValidation && clientValidation.length > 0){
                        clientValidation.push({id: clientId, uuid: uuid});

                    } else {
                        clientValidation = [{id: clientId, uuid: uuid}];
                    }

                    storage.saveWithTTL('CLIENT_VALIDATION', clientValidation, 43200);

                //===============================================================>

                const firstName = name.split(' ');

                setSucessAlert({show: true, data: firstName[0]});

            }

        } catch (error) {
            console.error('ERROR - REGISTER CLIENT DATA FUNCTION:', error);
            setWarnAlert({show: true, title: 'Erro', text: error?.response?.data?.error});
        
        } finally {
            setLoading(false);
        }
    };




    // SCREEN =======================================================================>
    return (
        <div style={{ flex: 1 }}>

            <div className={styles.screen}>
                <div className={styles.headerRegister} style={{backgroundColor: companyData.background_color}}>
                    <ReturnButton showText={true}/>
                    <p className={styles.titleHeader} style={{color: companyData.text_color}}>Registre-se</p>
                </div>

                <div className={styles.container}>
                    
                    <h1 id={styles.titleform}>Registre-se</h1>

                    <span id={styles.subtitleText}>
                        Insira seus dados para participar de promoções e sorteios de brindes nos estabelecimentos parceiros do <b>SofChef</b>!
                    </span>

                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 25 }}>
                        <div className={styles.formInputs}>
                            <div className={styles.inputArea} style={{borderColor: companyData.background_color}}>
                                <div className={styles.iconArea} style={{backgroundColor: companyData.background_color}}>
                                    <FaRegUser size={22} color={companyData.text_color}/>
                                </div>
                                <input className={styles.input} value={name} maxLength={120} placeholder="Nome completo" onChange={({ target: { value } }) => setName(stripHtmlTags(value))} />
                                {/* <input className={styles.input} value={name} placeholder="Nome completo" onChange={handleInputName} /> */}
                            </div>

                            <div className={styles.inputArea} style={{borderColor: companyData.background_color}}>
                                <div className={styles.iconArea} style={{backgroundColor: companyData.background_color}}>
                                    <FaPhoneAlt size={22} color={companyData.text_color}/>
                                </div>
                                <InputMask className={styles.input} mask='(__) _____-____' replacement={{_: /\d/}} value={phone} placeholder="Telefone" onChange={({ target: { value } }) => setPhone(value)} />
                            </div>

                            <div className={styles.inputArea} style={{borderColor: companyData.background_color}}>
                                <div className={styles.iconArea} style={{backgroundColor: companyData.background_color}}>
                                    <FaRegAddressCard size={22} color={companyData.text_color}/>
                                </div>
                                <InputMask className={styles.input} mask='___.___.___-__' replacement={{_: /\d/}} value={NI} placeholder="CPF" /*onChange={({ target: { value } }) => setNi(value)}*/ />
                            </div>

                            <div className={styles.inputArea} style={{borderColor: companyData.background_color}}>
                                <div className={styles.iconArea} style={{backgroundColor: companyData.background_color}}>
                                    <LiaBirthdayCakeSolid size={22} color={companyData.text_color}/>
                                </div>
                                <InputMask className={styles.input} mask='__/__/____' replacement={{_: /\d/}} value={birth} placeholder="Data de nascimento" onChange={({ target: { value } }) => setBirth(value)} />
                            </div>
                        </div>

                        <span style={{fontSize: 13, marginTop: 15, marginBottom: 15}}>Ao se registrar na plataforma, você concorda com nossos <a target='_blank' href="https://sofchef.com.br/terms-of-use" className={styles.footerLink}>Termos de uso</a> e com nossas <a target='_blank' href="https://sofchef.com.br/privacy-policies" className={styles.footerLink}>Políticas de privacidade</a></span>

                        <button className={styles.btnRegister} style={{backgroundColor: companyData.background_color}} onClick={async () => await handleValidateRegisterData()}>
                            {loading ? <ReactLoading type={'spin'} color={'#fff'} height={25} width={25} /> : <span className="text-button" style={{color: companyData.text_color}}>Cadastrar</span>}
                        </button>
                    </div>
                </div>

            </div>
            

            <a className={styles.buttonRedirect} href={'https://sofchef.com.br'} target='blank'>
                <img style={{width: 150}} src={require('../../assets/Logo.png')}/>
            </a>


            {/* SUCESS ALERT */}
            <BoxAlert
              show={sucessAlert.show}
              title={'Sucesso'}
              text={<p>Parabéns {sucessAlert.data}, agora você faz parte do sistema de benefícios do SofChef e estará concorrendo a promoções e brindes em suas próximas visitas ao {companyData.name}!</p>}
              onClose={() => navigate('cart')}
            />



            {/* WARN ALERT */}
            <BoxAlert
              show={warnAlert.show}
              title={warnAlert.title}
              text={<p>{warnAlert.text}</p>}
              onClose={() => setWarnAlert({show: false, title: null, text: null})}
            />
        </div>
    );
}

export default Register;
